import { styled } from "styled-components";
import { useAuthContext } from "../../contexts/AuthContext";
import { usePageContentContext } from "../../contexts/PageContentProvider";
import logger from "../../server/server";
import { Filters } from "../App/Filter/Filters";
import { Footer } from "../App/Footer";
import { Header } from "../App/Header";
import { Configurations } from "./Configurations";
import { Events } from "./Events";
import { Map } from "./Map";
import { Register } from "./Register";
import { RegisterDetail } from "./RegisterDetail";
import { NoPage } from "./NoPage";

//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: clip;
`;

const MainContent = styled.div`
    display: flex;
    height: calc(100% - 88px);
    /* overflow: hidden; */
    /* flex-direction: column; */
    /* min-height: 100vh - 93px; */
`;

const RightContent = styled.div`
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    width: 100%;
    overflow-y: auto;
    justify-content: space-between;
`;

const FiltersContainer = styled.div`
    display: block;
    z-index: 1;
`;
//#endregion
export function Home() {
    const { user, tenant } = useAuthContext();
    const { withFilters, currentPath } = usePageContentContext();

    function renderPage(currentPath) {
        try {
            const zones = JSON.parse(localStorage.getItem('mico_zones'));
            if(!Array.isArray(zones) || zones.length === 0){
                return <NoPage />;
            };
            if (currentPath) {
                if (currentPath?.includes('/map') && zones?.includes('map')) {
                    logger.info('User ' + user?.Username + ' went to map page! Tenant: ' + tenant)
                    return <Map />;
                }
                if (currentPath?.includes('/registry/building') && zones?.includes('registry')) {
                    logger.info('User ' + user?.Username + ' went to registry building page! Tenant: ' + tenant)
                    return <RegisterDetail />;
                }
                if (currentPath?.includes('/registry') && zones?.includes('registry')) {
                    logger.info('User ' + user?.Username + ' went to register page! Tenant: ' + tenant)
                    return <Register />;
                }
                if (currentPath?.includes('/events') && zones?.includes('events')) {
                    logger.info('User ' + user?.Username + ' went to events page! Tenant: ' + tenant)
                    return <Events />;
                }
                if (currentPath?.includes('/configurations') && zones?.includes('configurations')) {
                    logger.info('User ' + user?.Username + ' went to configurations page! Tenant: ' + tenant)
                    return <Configurations />;
                }
                else {
                    return <Map />;
                }
            };
        } catch (error) {
            console.error('(Home page) Error in rendering Page currenntPath:', error);
            //reportError(error); // Send error report to backend
            logger.error("(Home page) User " + user?.Username + " Tenant: " + tenant + ', Error in rendering Page currenntPath:', error)
        }
    }


    return (
        <Container>
            <Header />
            <MainContent>
                {withFilters ?
                    <FiltersContainer>
                        <Filters />
                    </FiltersContainer>
                    : null
                }

                <RightContent>
                    {renderPage(currentPath)}
                    {!currentPath?.includes('/map') && !currentPath?.includes('/') && !currentPath?.includes('/registry/building') && !currentPath?.includes('/configurations') ? <Footer /> : null}
                </RightContent>
            </MainContent>
        </Container>
    );
}